import React from "react";
import './TableTasks.scss';

const TableTasks = ({data}) => {

  const arrowDown = <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    fill="none"
    viewBox="0 0 16 16"
  >
    <path
      stroke="#FA4659"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
      d="M8 13.333V2.667M11.333 10S8.878 13.333 8 13.333C7.122 13.333 4.667 10 4.667 10"
    ></path>
  </svg>

  return (
    <div className='TableTasks-arka'>
      <h5>لیست تسک های تاخیر خورده</h5>

      <ul>
        <li className={"li-header"}>
          <h6 style={{width: "10%"}}>کد برنامه نویس</h6>
          <h6 style={{width: "30%"}}>نام برنامه نویس</h6>
          <h6 style={{width: "20%"}}>کد تسک</h6>
          <h6 style={{width: "30%"}}>وظیفه</h6>
          <h6 style={{width: "10%"}}>تاخیر برحسب روز</h6>
        </li>

        {data?.length > 0 ? data?.map((item, index) =>
          <li key={"row" + index}>
            <h6 style={{width: "10%"}}>{item?.programerId}</h6>
            <h6 style={{width: "30%"}}>{item?.programerName}</h6>
            <h6 style={{width: "20%"}}>{item?.taskId}</h6>
            <h6 style={{width: "30%"}}>{item?.taskTitle}</h6>
            <h6 style={{width: "10%"}}>{item?.delayByDay}</h6>
          </li>
        ) : <li className={"no-task"}>تسکی تاخیر خورده نیست</li>
        }
      </ul>

    </div>
  );
};

export default TableTasks;
